<template><!-- 應用關聯EDM -->
  <div v-if="application !== null">
    <h3>設定關聯EDM</h3>
    <div class="h4 py-5">
      前台Application內頁最多顯示6筆，依EDM發布日期新到舊自動排序；
      此處綁定的筆數若超過6筆，僅最新的6筆會顯示。
    </div>
    <!-- 搜尋並新增EDM -->
    <div class="d-flex align-center pa-5 brand-100">
      <label for="edmTitleAdd"><h4 class="mr-5 flex-shrink-0">添加EDM</h4></label>
      <div class="d-flex my-n2 flex-grow-1 align-center">
        <div class="where-to-buy-autocomplete mr-3 flex-shrink-0" style="width: 220px;">
          <v-select
            :items="edmsTypeOptions"
            v-model="selectedTab"
            placeholder="請選擇分類"
            item-value="value"
            item-text="text"
            style="background: white;"
            hide-details
            outlined
            dense
          >
          </v-select>
        </div>
        <div class="where-to-buy-autocomplete flex-grow-1">
          <v-autocomplete
            id="edmTitleAdd"
            :items="edmOptions"
            v-model="tempEdm"
            :disabled="!selectedTab"
            :loading="isLoadingOptions"
            placeholder="請先選擇分類，再搜尋EDM標題"
            item-value="id"
            item-text="title"
            style="background: white;"
            hide-details
            clearable
            return-object
            outlined
            dense
          >
          </v-autocomplete>
        </div>
        <div class="ml-5">
          <button
            v-if="tempEdm"
            class="btn btn-primary w-90px ml-5"
            @click="addEdm">
            新增
          </button>
          <button v-else class="btn btn-primary w-90px ml-5" disabled>
            新增
          </button>
        </div>
      </div>
    </div>

    <!-- 已綁定的EDM清單 -->
    <div class="form-item mt-5">
      <div
        v-if="!application.edms || application.edms.length === 0"
        class="h5 ink-02-medium--text py-5">
        尚未綁定任何EDM
      </div>
      <div
        v-for="(edm, i) in application.edms"
        :key="edm.id"
        class="d-flex align-center justify-space-between py-3">
        <div class="h5 ink-01-emphasis--text">
          {{ edm.title }}
          <span class="ink-02-medium--text" v-if="edm.tab_display">（{{ edm.tab_display }}）</span>
          <span class="ink-02-medium--text" v-if="edm.published_date">- {{ edm.published_date }}</span>
        </div>
        <button class="btn square" @click="deleteEdm(i)">
          <v-icon>delete</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  data: () => ({
    selectedTab: null,
    edmOptions: [],
    tempEdm: null,
    isLoadingOptions: false,
  }),
  computed: {
    ...mapState('application', ['application']),
    ...mapState('edms', ['edmsTypeOptions']),
  },
  watch: {
    async selectedTab(newTab) {
      this.tempEdm = null;
      this.edmOptions = [];
      if (!newTab) {
        return;
      }
      this.isLoadingOptions = true;
      try {
        const result = await this.allEdms(newTab);
        this.edmOptions = result.data || result;
      } finally {
        this.isLoadingOptions = false;
      }
    },
  },
  created() {
    if (!this.application.edms) {
      this.$set(this.application, 'edms', []);
    }
  },
  methods: {
    ...mapActions('edms', ['allEdms']),
    addEdm() {
      const hasEdm = this.application.edms.find((edm) => edm.id === this.tempEdm.id);
      if (hasEdm) {
        this.tempEdm = null;
        return;
      }
      // 統一欄位格式 (與後端已綁定清單回傳格式一致: title/tab_display/published_date)
      this.application.edms.push({
        id: this.tempEdm.id,
        title: this.tempEdm.title,
        tab_display: this.tempEdm.tab,
        published_date: this.tempEdm.published_at,
      });
      this.tempEdm = null;
    },
    deleteEdm(i) {
      this.application.edms.splice(i, 1);
    },
  },
};
</script>

<style lang="scss">
.where-to-buy-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    background: white;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
    font-size: 16px;
    line-height: 1.43;
  }
}
</style>
